<template class="">
    <div class="partnerlnquitry maincontainer">
        <h1 class="title">合作夥伴接洽</h1>
            <!-- (A) 資料未載入 => 佔位 min-height -->
            <div v-if="!loaded" class="placeholder">
            <p>載入中...</p>
            </div>

            <!-- (B) 資料載入後 => 用 v-html 插入, 再用 JS 做行/圖片淡入 -->
            <div
            v-else
            class="html-container"
            ref="htmlContainer"
            v-html="txthtml"
            ></div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { usePageStore } from '@/store/pageStore.js'

const txthtml = ref('')
const loaded = ref(false)
const htmlContainer = ref(null) // 指向插入 HTML 的外層容器

onMounted(async () => {
  // 1. 從 pinia store 取回 HTML 資料
  const pageStore = usePageStore()
  await pageStore.fetchPartnerInquiryData()

  txthtml.value = pageStore.PartnerInquiryHtml || ''

  // 2. 資料已到手 => loaded
  loaded.value = true

  // 3. 等 DOM 更新
  await nextTick()

  // 4. 初始化行與圖片的初始狀態 (opacity=0, translate等)
  initFadeElements()
  // 5. 分批逐行/逐圖 淡入
  fadeInElements()
})

function initFadeElements() {
  if (!htmlContainer.value) return

  // (1) 文字行: span, p, li, h2, blockquote
  const textLines = htmlContainer.value.querySelectorAll('span, p, li, h2, blockquote')
  textLines.forEach(el => {
    el.style.opacity = '0'
    el.style.transform = 'translateY(20px)'
    el.style.transition = 'all 0.4s ease'
  })

  // (2) 圖片: img
  const images = htmlContainer.value.querySelectorAll('img')
  images.forEach(img => {
    // 與您在 CSS `.maincontainer img { ... }` 初始狀態一致
    // 這裡可保險設一次 or 用 class remove/add
    img.style.opacity = '0'
    img.style.transform = 'translateY(20px) scale(0.8)'
    img.style.transition = 'opacity 1s ease, transform 1s ease'
  })
}

function fadeInElements() {
  if (!htmlContainer.value) return

  // 文字行
  const textLines = htmlContainer.value.querySelectorAll('span, p, li, h2, blockquote')
  // 圖片
  const images = htmlContainer.value.querySelectorAll('img')

  // (A) 分批淡入文字，每行相隔 200ms
  textLines.forEach((el, index) => {
    setTimeout(() => {
      el.style.opacity = '1'
      el.style.transform = 'translateY(0)'
    }, index * 200)
  })

  // (B) 若想把圖片安排在文字之後 or 同步，也可做類似計算
  //    例如: 先讓所有文字淡入結束後，再淡入圖片
  //    下例：若 textLines 有 n 行 → 文字會花 n*200 ms, 
  //          圖片接著每張再隔 300ms
  const startDelay = textLines.length * 200
  images.forEach((img, idx) => {
    setTimeout(() => {
      img.style.opacity = '1'
      img.style.transform = 'translateY(0) scale(1)'
    }, startDelay + idx * 300)
  })
}
</script>


<style scoped>
.maincontainer {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}

/* 佔位 */
.placeholder {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}


.title {
  text-align: center;
  margin-bottom: 1rem;
}
.placeholder {
  min-height: 200px; /* 先留空間 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}
/* 預留外層 (可根據需求) */
.html-container {
  /* 讓長文字自動換行 */
  overflow-wrap: break-word;
  word-wrap: break-word;
}
/* 不需要 transition-group => 自行 JS set style */
</style>

<style>

/* 圖片樣式 */
.partnerlnquitry img {
  display: block;       /* 使圖片成為區塊元素 */
  margin: 0 auto;       /* 水平置中 */
  width: 100%;          /* 圖片寬度適應容器 */
  max-width: 400px;     /* 限制圖片最大寬度 */
  opacity: 0;           /* 初始透明度為 0 */
  transform: translateY(20px) scale(0.8); /* 初始位置下移並縮小 */
  transition: opacity 1s ease, transform 1s ease, box-shadow 0.5s ease; 
  border-radius: 15px;  
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 
              0 4px 6px rgba(0, 0, 0, 0.06); 
  border: 5px solid #fff;
}

.partnerlnquitry img.fade-in {
  opacity: 1; 
  transform: translateY(0) scale(1); 
  box-shadow: 0 15px 20px rgba(0, 0, 0, 0.2), 
              0 6px 8px rgba(0, 0, 0, 0.1);
}

/* RWD 小螢幕 */
@media (max-width: 768px) {
  .partnerlnquitry img {
    max-width: 100%; 
    border-radius: 10px;
  }
}
</style>
